import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl"
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';

import { Modal, Button } from "react-bootstrap";
import * as Icon from 'react-bootstrap-icons';
import Settingspage from '../settings/settings';
import $ from "jquery";

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";


function Stafflist() {

    const accesstoken = localStorage.getItem("token");
    const sync = localStorage.getItem("sync");
    const Swal = require('sweetalert2')

    const [data, setData] = useState([]);
    const [button, setbutton] = useState("Users");
    const [User, setUser] = useState(false);
    const [role, setrole] = useState(false);
    const [group, setgroup] = useState(false);
    const [value, setvalue] = useState("");
    const [show, setshow] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        const GetAllUsers = () => {
            axios
                .get(baseurladdress + `findallstaff`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then(res => {
                    const datas = res.data.response;
                    console.log("itemss" + datas);
                    const user = datas.map((item, index) => (

                        <tr  id={"chk" + item.staff_id} >
                            <td>{index + 1}</td>
                            <td>{item.staff_code}</td>
                            <td>{item.staff_name}</td>
                            <td>{item.staff_place}</td>
                            <td>{item.staff_mobile}</td>
                            <td >        <div>
                                {(() => {
                                    if (item.staff_status == 1) {
                                        return (
                                            <div>
                                                <span class="badge bg-success" >
                                                    Active
                                                </span>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div>
                                                <span class="badge bg-danger" >
                                                    Inactive
                                                </span>
                                            </div>
                                        );
                                    }
                                })()}
                            </div></td>

                            <td>
                                {/* <span> <Icon.PencilSquare
  color="royalblue"
  size={20}

/></span> */}
                                <i class="text-primary fa fa-edit"  style={{ cursor: "pointer" }} onClick={() => EditStaff(item.staff_id)}></i>



                            </td>

                            <td style={{textAlign: "center"}}>
                                <i class="text-danger fa fa-trash"  style={{ cursor: "pointer" }} onClick={() => deleteStaff(item.staff_id)}></i>
                            </td>
                        </tr>
                    ));

                    setData(user);
                })
                .catch(error => {
                    alert(error);
                })
        }

        GetAllUsers();
    }, []);

    function deleteStaff(staff_id) {

        if (
            window.confirm(
                "Are you sure you want to delete this data? This cannot be undo later."
            )
        ) {
            fetch(baseurladdress + `deletestaff/${staff_id}`, {
                method: "POST",

                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }).then((response) => {
                if (response.status === 200) {

                    $("#chk" + staff_id).fadeOut(200, function () { $(this).css('display', 'none'); });
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'success',
                        title: 'Deleted Successfully'
                    })

                    // alert("Deleted Successfully");
                    window.location.reload();



                }

            });
        }
    };

    function AddStaff() {
        //window.location.href = "/AddStaff";
        navigate("/AddStaff");
    }

    function EditStaff(staff_id) {
        //window.location.href = "/AddStaff";
        navigate("/Editstaff/" + staff_id);
    }

    $(function () {
        setTimeout(function () {
            $('#staff').DataTable();
        }, 1000);
    });
    return (

        <div className="content-wrap">

            <div className="main">
                <div className="container-fluid">

                    {/* /# row */}
                    <section id="main-content">

                        <div class="card">
                            <div class="card-header" style={{ "color": "black" }}>
                                Staff List{value}
                            
                            <div className="d-flex align-items-center">
                                <button
                                    type="button"
                                    className="btn plus-icon d-flex align-items-center"
                                    onClick={() => AddStaff()}
                                    style={{ marginRight: '50px' }} // Adjust spacing as needed
                                >
                                    <span style={{ fontSize: "1.2rem" }}><i className='fa fa-plus-circle text-success'></i></span>
                                    <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}> Add</span>
                                </button>


                            </div>

                            </div>

                            <div class="card-body">
                                {/* <div class="row mb-2">

                                    <div class="col-sm-12 float-lg-right text-right">
                                        <button
                                            type="button"
                                            class="d-grid gap-2 d-md-flex justify-content-md-end"
                                            className="btn btn-primary"
                                            onClick={() => AddStaff()}
                                        >
                                            Add Staff
                                        </button>
                                    </div>
                                </div> */}



                                <div className="col-lg-12">
                                    <div className="card">

                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-responsive-sm" id='staff'>
                                                    <thead>
                                                        <tr>

                                                            <th>Sl.No</th>
                                                            <th>Staff Code</th>
                                                            <th>Staff Name</th>
                                                            <th>Place</th>
                                                            <th>Contact</th>
                                                            <th>Status</th>
                                                            <th>Edit</th>
                                                            <th>Delete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>



                        {/* /# column */}

                    </section>
                </div>
            </div>
        </div>

    )





}

export default Stafflist;